import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { UtilService } from 'src/app/shared/utils/utils.service';
import { InternalTemplateApi } from '../APIs/internal-template.api';
import { InternalTemplateEntity } from '../entities/internal-template.entity';
import { DomainTranslateService } from '../utils/domain-translate.service';

@Injectable({
    providedIn: 'root',
})
export class InternalTemplateController {
    private _api = inject(InternalTemplateApi);

    // * [Injects]
    private _utilService = inject(UtilService);
    private _i18n = inject(DomainTranslateService);

    /**
     * Busca todos os modelos internos da company
     * @param category Categoria do modelo interno
     * @returns InternalTemplateEntity[]
     */
    public getAll(category?: string): Observable<InternalTemplateEntity[]> {
        return this._api.getAll(category).pipe(
            map(response => response.body),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.common.errors.fetchInternalTemplates')
                )
            )
        );
    }
}
